import { baseApi } from '@klp/core/api';
import { sortList } from '@klp/utils/listUtils';
import type { IUtestaaendeFordringerRequest } from '../interfaces/IUtestaaendeFordringerRequest';
import type { IUtestaaendeFordringerForsinkede } from '../interfaces/IUtestaaendeFordringerForsinkede';
import type { IUtestaaendeFordringerResponse } from '../interfaces/IUtestaaendeFordringerResponse';
import { generateApiRoute } from '@klp/core/api/helpers';

const utestaaendeFordringerApiName = 'portfolio';

const UtestaaendeFordringerRoutes = {
    utestaaendeFordringer: () =>
        generateApiRoute([utestaaendeFordringerApiName, 'forfallkunder']),
};

const defaultRequest: IUtestaaendeFordringerRequest = {
    antall: 5,
    forvalter: '',
    bygg: '',
};

export const utestaaendeFordringerApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getUtestaaendeFordringer: build.query<
            IUtestaaendeFordringerResponse,
            IUtestaaendeFordringerRequest
        >({
            query: (requestParams) => ({
                url: UtestaaendeFordringerRoutes.utestaaendeFordringer(),
                params: { ...defaultRequest, ...requestParams },
                method: 'GET',
            }),
            transformResponse: (
                response: Array<IUtestaaendeFordringerForsinkede>,
                _meta,
                arg,
            ): IUtestaaendeFordringerResponse => {
                const forsinkede = response
                    ?.sort(
                        sortList<IUtestaaendeFordringerForsinkede>(
                            'sumForsinket',
                            'maksAntallDagerForsinket',
                            'desc',
                        ),
                    )
                    .slice(0, arg.antall || 3);
                return { forsinkede };
            },
            providesTags: ['UtestaaendeFordringer'],
        }),
    }),
});

export const {
    useGetUtestaaendeFordringerQuery,
    useLazyGetUtestaaendeFordringerQuery,
} = utestaaendeFordringerApi;
